<template>
    <div class="file"  >
        <label class="file-label">
          <input enctype="multipart/form-data" class="file-input" type="file" name="resume" accept="extensoesPermitidas" @change="$emit('uploadFile', $event)">
          <span class="button is-primary" :style="customButtonStyle">
            <span class="file-label">
             {{ name }}
            </span>
          </span>
        </label>
      </div>
</template>

<script>
export default {
    name: "TrfButtonUpload",
    emits: ['uploadFile'],
    props: {
        name: String,
        customButtonStyle: String,
        extensoesPermitidas: String,
    }
}
</script>

<style lang="scss" scoped>
label {
    margin-bottom: 0;
}
</style>
